import { RefreshCw } from 'lucide-react'

type AutoSyncStatusProps = {
  intervalSeconds: number
  lastSyncedAt?: Date
  refreshing: boolean
  onRefresh: () => void
}

export function AutoSyncStatus({ intervalSeconds, lastSyncedAt, refreshing, onRefresh }: AutoSyncStatusProps) {
  const lastSync = lastSyncedAt
    ? lastSyncedAt.toLocaleTimeString('zh-CN', { hour12: false })
    : '等待首次同步'
  return <div className="auto-sync-status" title={`页面可见时每 ${intervalSeconds} 秒同步，切回页面立即同步`}>
    <span><i className={refreshing ? 'is-syncing' : ''} /><b>{refreshing ? '同步中' : '自动同步'}</b><small>{lastSync}</small></span>
    <button type="button" onClick={onRefresh} disabled={refreshing} aria-label="立即同步"><RefreshCw size={14} /></button>
  </div>
}
